module.exports = __webpack_public_path__ + "static/design_preview_pc-b1eae9cb5b080904e91c576bbbc61526.png";